import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CarregamentoService } from '../service/carregamento/carregamento.service';

// URLs que não devem ativar o spinner de loading
const URLS_IGNORADAS = [
  '.well-known/openid-configuration',
  '/auth/realms/',
  '/protocol/openid-connect/',
  'jwks',
  'sentry.io'
];

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const carregamentoService = inject(CarregamentoService);

  // Verifica se a URL deve ser ignorada pelo interceptor de loading
  const deveIgnorar = URLS_IGNORADAS.some(url => req.url.includes(url));

  if (deveIgnorar) {
    return next(req);
  }

  // Mostra o loading
  carregamentoService.Ativar();

  return next(req).pipe(
    finalize(() => {
      // Oculta o loading quando a requisição terminar (sucesso ou erro)
      carregamentoService.Desativar();
    })
  );
};
